import ShortcutDisplay from "../../../../src/components/ShortcutDisplay";
import panel from "../../../../assets/images/docs/panel.png";
import * as React from 'react';
export default {
  ShortcutDisplay,
  panel,
  React
};